import { FRESHA_BOOKING_URL } from "../config";
import { Zap, Layers, ShieldCheck } from "lucide-react";
import { LegalLayout, LegalSection } from "../components/LegalLayout";

const COOLITE_BANNER =
  "https://customer-assets-lqy194kg.emergentagent.net/job_216d3c35-aa83-4452-b36d-63c5224739d4/artifacts/tl022qeb_coolite.png";
const COOLITE_DEVICE =
  "https://customer-assets-lqy194kg.emergentagent.net/job_216d3c35-aa83-4452-b36d-63c5224739d4/artifacts/22ssk5ie_WhatsApp%20Image%202026-08-24%20at%2020.25.21.jpeg";
const features = [
  {
    icon: Layers,
    title: "Drei Wellenlängen",
    text: "755 nm, 810 nm und 1064 nm gleichzeitig – für optimale Abdeckung und Eindringtiefe bei unterschiedlichen Haarfollikeln.",
  },
  {
    icon: Zap,
    title: "Blitzschnell",
    text: "Bekannt für seine hohe Geschwindigkeit und hervorragenden Resultate – kürzere Behandlungszeiten für Sie.",
  },
  {
    icon: ShieldCheck,
    title: "Sicher & komfortabel",
    text: "Ultrakurze Impulse erhitzen die Haarfollikel gleichmässig, ohne die Oberhaut zu erwärmen – maximale Sicherheit und Komfort.",
  },
];

export default function CooliteBoltLaser() {
  const hero = (
    <div
      className="relative w-full min-h-screen overflow-hidden bg-[#1A1A1A]"
      data-testid="coolite-hero"
    >
      <img
        src={COOLITE_BANNER}
        alt="Coolite Bolt Laser Gerät"
        data-testid="coolite-hero-img"
        className="kenburns absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/10 to-black/85" />
      <div className="relative min-h-screen max-w-7xl mx-auto flex flex-col justify-end pb-16 md:pb-24 px-6 md:px-12 lg:px-24">
        <p className="text-sm tracking-[0.3em] uppercase text-[#C5A059] mb-4 fade-up">
          Technologie
        </p>
        <h1 className="font-playfair text-4xl sm:text-5xl lg:text-6xl text-white mb-4 fade-up fade-up-delay-1">
          Coolite Bolt Laser
        </h1>
        <p className="text-white/85 text-base md:text-lg max-w-xl fade-up fade-up-delay-2">
          Modernste Laser-Technologie für dauerhafte Haarentfernung und
          Hautverjüngung.
        </p>
      </div>
    </div>
  );

  return (
    <LegalLayout eyebrow="Technologie" title="Coolite Bolt Laser" hero={hero}>
      {/* Intro */}
      <LegalSection heading="Ein Laser, drei Wellenlängen">
        <p>
          Der Coolite BOLT Laser zur dauerhaften Haarentfernung und
          Hautverjüngung sendet gleichzeitig Laserstrahlen mit drei
          Wellenlängen aus, um unterschiedliche Haarfollikel zu erreichen:
          755 nm, 810 nm und 1064 nm. Die Kombination dieser drei Wellenlängen
          sorgt für eine optimale Abdeckung und Eindringtiefe – und damit für
          ein optimales Ergebnis.
        </p>
      </LegalSection>

      {/* Feature grid */}
      <LegalSection>
        <div className="grid sm:grid-cols-2 gap-6" data-testid="coolite-features">
          {features.map((f) => (
            <div
              key={f.title}
              className="bg-white border border-[#E5E5E5] p-6 md:p-8 hover:border-[#C5A059] transition-colors duration-300"
            >
              <div className="w-11 h-11 rounded-full bg-[#C5A059]/15 flex items-center justify-center text-[#C5A059] mb-4">
                <f.icon size={20} />
              </div>
              <h3 className="font-playfair text-xl text-[#1A1A1A] mb-2">
                {f.title}
              </h3>
              <p className="text-sm text-[#666666] leading-relaxed">{f.text}</p>
            </div>
          ))}
        </div>
      </LegalSection>

      {/* Device + detail */}
      <LegalSection>
        <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center">
          <div className="overflow-hidden border border-[#E5E5E5] bg-white flex items-center justify-center">
            <img
              src={COOLITE_DEVICE}
              alt="Coolite Bolt Laser – Anwendung"
              className="w-full h-auto max-h-[420px] object-contain"
            />
          </div>
          <div className="space-y-4 text-[#666666] leading-relaxed">
            <h3 className="font-playfair text-2xl text-[#1A1A1A]">
              Höchste Effizienz, maximaler Komfort
            </h3>
            <p>
              Der leistungsstarke Coolite BOLT Laser gibt ultrakurze Impulse ab,
              um die Haarfollikel in kürzester Zeit gleichmässig auf die optimale
              Temperatur zu erhitzen – ohne die Oberhaut (Epidermis) zu erwärmen.
            </p>
            <p>
              Das Ergebnis: maximale Sicherheit, höchster Komfort und
              beeindruckende Effizienz bei jeder Behandlung.
            </p>
            <a
              href={FRESHA_BOOKING_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="coolite-cta"
              className="btn-primary inline-block mt-2"
            >
              Termin buchen
            </a>
          </div>
        </div>
      </LegalSection>
    </LegalLayout>
  );
}
